
import { baseUrl } from "../../constants";
import { getDDDeptCall, getDDAreaCall, getDDCompCall, getDDLocCall  , 
    getDDFacilityCall, getDDEquCall, getDDSubEquCall } from "../../redux/actions/dropDown";
import { setFullLoad } from "../../redux/actions/common";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    "formTitle": "Add Ship Class",
    "tableTitle": "Ship Class List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(setFullLoad(true));
            const dropDownArr = [
                getDDDeptCall, getDDAreaCall, getDDCompCall, getDDLocCall  , 
                getDDFacilityCall, getDDEquCall, getDDSubEquCall
            ];
            setTimeout(()=>{
                dispatch(setFullLoad(false));
            }, 500);
            dropDownArr.forEach((func,) => {
                    dispatch(func());
            });
        },
        list: {
            url: `${baseUrl}/api/mms/device/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/device`,
        edit: `${baseUrl}/api/mms/device/edit`,
        delete: `${baseUrl}/api/mms/device/remove`
    },
    "tableCol": [
        // {
        //     name: 'Company',
        //     selector: row => row.comp_id,
        //     sortable: true
        // },
        // {
        //     name: 'Location',
        //     selector: row => row.loc_id,
        //     sortable: true
        // },
        // {
        //     name: 'Department',
        //     selector: row => row.department_id,
        //     sortable: true
        // },
        // {
        //     name: 'Area',
        //     selector: row => row.area_id,
        //     sortable: true
        // },
        // {
        //     name: 'Facility',
        //     selector: row => row.facility_id,
        //     sortable: true
        // },
        // {
        //     name: 'Equipment',
        //     selector: row => row.equipment_id,
        //     sortable: true
        // },
        // {
        //     name: 'Sub Equipment',
        //     selector: row => row.sub_equipment_id,
        //     sortable: true
        // },
        {
            name: 'Device',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                // {
                //     type: 'select',
                //     label: 'Company',
                //     name: 'comp_id',
                //     "options": []
                // },
                // {
                //     type: 'select',
                //     label: 'Location',
                //     name: 'loc_id',
                //     "options": []
                // },
                // {
                //     type: 'select',
                //     label: 'Department',
                //     name: 'department_id',
                //     "options": [
                //         "Agency",
                //         "logistics"
                //     ],
                //     "required": true
                // },
                // {
                //     type: 'select',
                //     label: 'Area',
                //     name: 'area_id',
                //     "options": [
                //         "Admin",
                //         "Process"
                //     ],
                //     "required": true
                // },
                // {
                //     type: 'select',
                //     label: 'Facility',
                //     name: 'facility_id',
                //     "options": [
                //         "Admin",
                //         "Process"
                //     ],
                //     "required": true
                // },
                // {
                //     type: 'select',
                //     label: 'Equipment',
                //     name: 'equipment_id',
                //     "options": [
                //         "Admin",
                //         "Process"
                //     ],
                //     "required": true
                // },
                // {
                //     type: 'select',
                //     label: 'Sub Equipment',
                //     name: 'sub_equipment_id',
                //     "options": [
                //         "Admin",
                //         "Process"
                //     ],
                //     "required": true
                // },
                {
                    type: 'text',
                    label: 'Device',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "department": 1,
        "area": 1,
        "facility": 1,
        "equipment": 1,
        "subEquipment": 1,
        "device": "safds"
    }]
}
